import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const allowedPaths = [
  "/dashboard",
  "/profile",
  "/deposit",
  "/payment",
  "/withdraw",
  "/packages",
  "/mytask",
  "/my-task",
  "/referral",
  "/transactions",
];

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, authChecked, user } = useAuth(); // ✅ এখন user নিয়েছি
  const location = useLocation();

  if (!authChecked) return null; // auth loading

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Suspended check
  if (user?.accountStatus === "Suspended") {
    return <Navigate to="/suspended" replace />;
  }

  const currentPath = location.pathname.split("/").slice(0, 2).join("/");
  const isAllowed = allowedPaths.some(path =>
    currentPath.startsWith(path)
  );

  if (!isAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;